/**
 * chatUIReducer - Manages chat UI state
 * Handles sidebar, panel widths, and document visibility
 */

const initialState = {
  sidebarCollapsed: false,
  documentPanelVisible: false,
  chatPanelWidth: 55,
  documentPanelWidth: 45,
  mobileHistoryOpen: false,
};

const chatUIReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR':
      return {
        ...state,
        sidebarCollapsed: !state.sidebarCollapsed,
      };

    case 'SET_SIDEBAR_COLLAPSED':
      return {
        ...state,
        sidebarCollapsed: action.payload,
      };

    case 'SET_PANEL_WIDTHS':
      return {
        ...state,
        chatPanelWidth: action.payload.chatWidth,
        documentPanelWidth: action.payload.documentWidth,
      };

    case 'OPEN_DOCUMENT_PANEL':
      return {
        ...state,
        documentPanelVisible: true,
      };

    case 'CLOSE_DOCUMENT_PANEL':
      return {
        ...state,
        documentPanelVisible: false,
      };

    case 'SET_DOCUMENT_PANEL_VISIBLE':
      return {
        ...state,
        documentPanelVisible: action.payload,
      };

    case 'SET_MOBILE_HISTORY_OPEN':
      return {
        ...state,
        mobileHistoryOpen: action.payload,
      };

    default:
      return state;
  }
};

export default chatUIReducer;
